import { useState, useEffect } from 'react';
import { obtenerEjercicios, crearRutina } from '../services/apiService';
import { Ejercicio } from '../services/apiService';

type Alumno = {
  id: string;
  nombre: string;
};

export default function AsignarEjercicios() {
  const [alumnos, setAlumnos] = useState<Alumno[]>([]);
  const [ejercicios, setEjercicios] = useState<Ejercicio[]>([]);
  const [seleccionados, setSeleccionados] = useState<Ejercicio[]>([]);
  const [rutinaNombre, setRutinaNombre] = useState('');
  const [duracion, setDuracion] = useState('');
  const [alumnoId, setAlumnoId] = useState('');
  const adminId = localStorage.getItem('id');

  useEffect(() => {
    fetch('http://localhost:5001/api/usuarios')
      .then(res => res.json())
      .then(setAlumnos)
      .catch(() => alert('❌ Error al cargar alumnos'));

    obtenerEjercicios()
      .then(setEjercicios)
      .catch(() => alert('❌ Error al cargar ejercicios'));
  }, []);

  const toggleEjercicio = (ejercicio: Ejercicio) => {
    setSeleccionados(prev =>
      prev.find(e => e.id === ejercicio.id)
        ? prev.filter(e => e.id !== ejercicio.id)
        : [...prev, ejercicio]
    );
  };

  const guardarRutina = async () => {
    if (!adminId || !alumnoId || !rutinaNombre || !duracion || seleccionados.length === 0) {
      return alert('⚠️ Completá todos los campos antes de guardar');
    }

    const rutina = {
      nombre: rutinaNombre,
      nivel: 'personalizada',
      duracion: Number(duracion),
      ejercicios: seleccionados,
      usuarioId: alumnoId,
      adminId,
    };

    try {
      await crearRutina(rutina);
      alert('✅ Rutina asignada correctamente');
      setSeleccionados([]);
      setRutinaNombre('');
      setDuracion('');
      setAlumnoId('');
    } catch {
      alert('❌ Error al guardar rutina');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <h2 className="text-2xl font-bold mb-6 text-center">📋 Crear rutina para alumno</h2>

      <div className="bg-white rounded shadow p-4 max-w-xl mx-auto mb-6">
        <select
          value={alumnoId}
          onChange={e => setAlumnoId(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-3"
        >
          <option value="">👤 Seleccioná alumno</option>
          {alumnos.map(al => (
            <option key={al.id} value={al.id}>{al.nombre}</option>
          ))}
        </select>

        <input
          type="text"
          placeholder="📛 Nombre de la rutina"
          value={rutinaNombre}
          onChange={e => setRutinaNombre(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-3"
        />

        <input
          type="number"
          placeholder="⏱️ Duración en minutos"
          value={duracion}
          onChange={e => setDuracion(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-4"
        />

        <button
          onClick={guardarRutina}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded"
        >
          Guardar rutina
        </button>
      </div>

      <h3 className="text-xl font-bold mb-4 text-center">🧠 Ejercicios disponibles</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {ejercicios.map(ej => (
          <div
            key={ej.id}
            onClick={() => toggleEjercicio(ej)}
            className={`cursor-pointer p-4 bg-white shadow rounded border-2 ${
              seleccionados.find(e => e.id === ej.id) ? 'border-green-500' : 'border-transparent'
            }`}
          >
            <img src={ej.imagenURL} alt={ej.nombre} className="w-full h-36 object-cover rounded mb-2" />
            <h4 className="font-semibold text-lg">{ej.nombre}</h4>
            <p className="text-sm text-gray-600">Grupo muscular: {ej.grupoMuscular}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
